import { prop, theme } from 'styled-tools';

import { Row } from 'react-styled-flexboxgrid';
import Section from '@/components/ui/Section';
import SectionHeadline from '@/components/ui/elements/SectionHeadline';
import breakpoint from 'styled-components-breakpoint';
import { rem } from 'polished';
import styled from 'styled-components';

const StyledSection = styled(Section)`
  position: relative;
  padding-top: 2rem;
  overflow: hidden;
`;
const BgBumper = styled.div`
  position: absolute;
  z-index: -1;
  left: 0;
  bottom: -2px;
  width: 100%;
  background-color: ${theme('colors.white')};
  height: 3rem;
  ${breakpoint('xs', 'sm')`
    height: 2rem;
  `}
`;

const HeadlineRow = styled(Row)`
  z-index: 90;
  position: absolute;
  bottom: 0px;

  ${breakpoint('xs', 'sm')`
    padding-top: 5rem;
  `}

  ${SectionHeadline} {
    display: inline;
    color: ${theme('colors.blue')};
    font-weight: bold;
    word-break: normal;
    white-space: pre-wrap;
    font-size: ${prop('lg', 48)}${prop('fontUnit', 'px')};
    line-height: ${prop('lhLg', '1.3em')};
    ${breakpoint('md', 'lg')`
      font-size: ${prop('md', 48)}${prop('fontUnit', 'px')}
    `}
    ${breakpoint('sm', 'md')`
      font-size: ${prop('sm', 40)}${prop('fontUnit', 'px')}
    `}
    ${breakpoint('xs', 'sm')`
      font-size: ${prop('xs', 32)}${prop('fontUnit', 'px')}
    `}
  }
`;

const DescriptionRow = styled(Row)`
  p {
    font-size: ${rem(24)};
    line-height: ${rem(33)};
    font-weight: normal;
  }
`;

const SkillRow = styled(Row)``;

const SkillBlock = styled.aside`
  position: relative;
  border-top: 4px solid ${theme('colors.orange')};
  padding: 0;
  margin-bottom: 6rem;
  text-align: left;
  color: ${theme('colors.blue')};

  h3 {
    font-size: ${rem(40)};
    line-height: ${rem(49)};
    font-weight: bold;
    margin: 1rem 0 1rem 0;
  }

  p,
  div {
    font-size: ${rem(20)};
    line-height: ${rem(28)};

    span {
      color: ${theme('colors.orange')};
    }

    mark {
      color: ${theme('colors.white')};
      background-color: ${theme('colors.orange')};
    }

    a {
      color: ${theme('colors.orange')};
      text-decoration: underline;
    }
  }
`;

export { StyledSection, BgBumper, HeadlineRow, DescriptionRow, SkillRow, SkillBlock };
